import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4","key":"svg-0"}]]

const IconLetterS = createReactComponent('outline', 'letter-s', 'LetterS', __iconNode);

export default IconLetterS;